import React from "react";

import academy from '../../../img/logo_wbs_akademie.svg'
import group from '../../../img/logo_wbs_gruppe.svg'
import schools from '../../../img/logo_wbs_schulen.svg'
import training from '../../../img/logo_wbs_training.svg'
import codingSchool from '../../../img/logo-wbs-coding-school.svg'
import recruiting from '../../../img/logo-wbs-recruiting-international.svg'

const Brands = (): JSX.Element => {
  return (
    <>
      <div className="row p-4 m-0">
        <div className="col-lg-2 col-md-12 my-4 text-center">
          <a href="https://www.wbs-gruppe.de/" target="_blank" rel="noopener noreferrer">
            <img className="img-fluid brand-images" src={group} alt="" />
          </a>
        </div>

        <div className="col-lg-1 col-md-12 my-4 text-center">
          <div className='seperator'></div>
        </div>

        <div className="col-lg-9 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6 my-4 text-center">
              <a href="https://www.wbstraining.de/" target="_blank" rel="noopener noreferrer">
                <img className="img-fluid brand-images" src={training} alt="" />
              </a>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 my-4 text-center">
              <a href="https://www.wbsakademie.de/" target="_blank" rel="noopener noreferrer">
                <img className="img-fluid brand-images" src={academy} alt="" />
              </a>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 my-4 text-center">
              <a href="https://www.wbs-schulen.de/" target="_blank" rel="noopener noreferrer">
                <img className="img-fluid brand-images" src={schools} alt="" />
              </a>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 my-4 text-center">
              <a href="https://www.wbscodingschool.com/" target="_blank" rel="noopener noreferrer">
                <img className="img-fluid brand-images" src={codingSchool} alt="" />
              </a>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 my-4 text-center">
              <a href="https://www.wbsrecruiting-international.de/" target="_blank" rel="noopener noreferrer">
                <img className="img-fluid brand-images" src={recruiting} alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brands;
